import { Injectable } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class FaqService {

  urlBlobPdf: SafeUrl;
  urlBlobUntrusted: string;
  urlAwsBucketPdf: string;

  constructor(
    private sanitizer: DomSanitizer,
    private apiService: ApiService
    ) { }


  obterUrlBlob(): Observable<SafeUrl> {
    return this.apiService.obterLinkPdfFaq().pipe(
      mergeMap(
        async url => {
          let blob = await fetch(url).then(r => r.blob());
          this.urlBlobUntrusted = window.URL.createObjectURL(blob);
          return this.sanitizer.bypassSecurityTrustUrl(this.urlBlobUntrusted);
        }
      )
    )
  }

}
